import { axiosInstance } from "../network";
import { API_URL } from "../../constants";

export default {
  planBusinessName: (data) => {
    return axiosInstance.post(API_URL.PLAN_BUSINESSNAME, data);
  },

  getBusinessName: (id) => {
    return axiosInstance.get(`${API_URL.PLAN_BUSINESSNAME}/${id}`);
  },

  getAllProduct: () => {
    return axiosInstance.get(API_URL.PRODUCT, {
      params: {
        pageSize: 250,
      },
    });
  },

  getAllProductById: (id) => {
    return axiosInstance.get(`${API_URL.PRODUCT}/${id}`);
  },

  getOngoingPricing: (id) => {
    return axiosInstance.get(`${API_URL.PRICING}/packages/${id}`);
  },

  getAllState: () => {
    return axiosInstance.get(API_URL.STATE);
  },
};
